import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import api from "./api";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadCheckList(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;

    let checklist = getState().document.checklist[key];
    if (checklist) {
      loading = checklist.loading;
      loaded = checklist.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_CHECKLIST_STARTED, id: key });
      checklist = await dispatch(sendHttpRequest(api.loadCheckList(documentId, siteId)));

      const payload = checklist.items.map(x => {
        return { ...x, key: `${x.documentId}-${x.siteId}-${x.id}` };
      });
      dispatch({ type: actionTypes.LOAD_CHECKLIST_SUCCESS, payload: payload, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateCheckList(offerId, offerSiteId, folderId, folderSiteId, checklist) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.updateCheckList(offerId, offerSiteId, folderId, folderSiteId, checklist),
          "updateCheckListCommand",
          [eventTypes.CHECKLIST_INVALIDATED]
        )
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
